
import { Box, Typography } from '@mui/material'
import React from 'react'

import { Motion } from './Motion';
import { Link, useNavigate } from 'react-router-dom';
import { pastelOrange, textStyle, titleStyle } from '../Pages/Main/constants';
import { EditableTypography } from './EditableTypography';
import EditableImage from './EditableImage';
import { logAnalytics } from '../Firebase/firebase_init';


export default function Holder({ data, link, sx = {}, path }) {
    const navigate = useNavigate();

    return (
        <Motion scale={1.01}>
            <Box sx={{
                borderRadius: '20px', bgcolor: 'white', width: { xs: '100%', sm: '460px', md: '380px' },
                display: 'flex', flexDirection: 'column',
                boxShadow: '1px 1px 2px 0px rgba(0,0,0,0.2)', cursor: 'pointer', ...sx
            }} onClick={() => {
                logAnalytics("program_open", { program: data?.tag });
                navigate(`/program/${data.tag}`);
            }}>
                {<EditableImage alt={`${data.tag}`} noPropagation comment='Program-specific' path={path + '.img'} sx={{
                    width: "100%", height: { xs: '420px', sm: '480px', md: '380px' }, objectFit: 'cover',
                    borderTopLeftRadius: '20px', borderTopRightRadius: '20px'
                }} />}
                <Box sx={{
                    bgcolor: 'white', p: '24px', px: '32px',
                    display: 'flex', flexDirection: 'column',
                    borderBottomLeftRadius: '20px', borderBottomRightRadius: '20px',
                }}>

                    <EditableTypography comment='Program-specific text' noPropagation path={path + '.title'} bottom={'auto'} top={-30} sx={{ my: '6px', ...titleStyle, fontSize: '24px !important', lineHeight: '32px' }} />

                    <EditableTypography comment='Program-specific text' noPropagation path={path + '.text'} bottom={'auto'} top={-30} sx={{ mt: '12px', ...textStyle }} />

                    <EditableTypography comment='Program-specific text' noPropagation path={path + '.age'} top={'auto'} bottom={-30} right={-30} sx={{ mt: '32px', ...textStyle }} />

                    <Box sx={{ mt: 'auto', borderRadius: '20px', }}>
                        <Motion style={{ width: 'fit-content', marginTop: '32px', marginBottom: '16px' }} scale={1.04}>
                            <Box component={Link} to={link} sx={{
                                display: 'flex', flexDirection: 'row', borderRadius: '20px', bgcolor: pastelOrange,
                                width: 'fit-content', height: '38px', mb: 'auto', cursor: 'pointer', textDecoration: 'none',
                            }}>
                                <Typography sx={{ ...textStyle, p: '8px', px: '16px', fontSize: '14px', fontWeight: 500, color: 'white' }}>
                                    Zjistit více
                                </Typography>
                            </Box>
                        </Motion>
                    </Box>
                </Box>
            </Box>
        </Motion>

    )
}
